import { Link } from "react-router-dom";
import * as React from "react";
import { developAxios } from "../axios.config";
import { Alert } from "react-bootstrap";

const DeleteProject = () => {
	const [projects, setProjects] = React.useState([]);
	const [project, setProject] = React.useState("");

	const [course, setCourse] = React.useState("");
	const [courses, setCourses] = React.useState([]);

	// select course
	React.useEffect(() => {
		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/getallcourse", {
				signal: controller.signal,
			})
			.then(({ data }) => {
				console.log(data);
				setCourses(data.courses);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, []);

	React.useEffect(() => {
		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/dashboard/get-projects-by-courseId/" + course, {
				signal: controller.signal,
			})
			.then(({ data }) => {
				console.log(data);
				setProjects(data.projects);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, [course]);

	const handleSubmit = (e) => {
		e.preventDefault();
		developAxios(localStorage.getItem("token"))
			.delete("/dashboard/delete-project/" + project)
			.then(({ data }) => {
				console.log(data);
				alert("Project Deleted Successfully");
				window.location.reload();
			})
			.catch((err) => console.log(err?.response));
	};

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "flex-start",
				flexDirection: "column",
			}}
		>
			<div
				style={{
					alignSelf: "center",
					width: "500px",
					paddingBottom: "50px",
					paddingTop: "50px",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<h5>Course ID:</h5>{" "}
					<select
						// className="w-50"
						aria-label="Default select example"
						name="course_select"
						id="course_select"
						onChange={(e) => {
							// set id of course
							setCourse(e.target.value);
						}}
					>
						<option value="">Select course</option>
						{courses.map((val) => {
							return (
								<option value={val._id} key={val.id}>
									{val?.name}
								</option>
							);
						})}
					</select>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "30px",
					}}
				>
					<h5>Projects:</h5>{" "}
					<select
						// className="w-50"
						aria-label="Default select example"
						name="course_select"
						id="course_select"
						onChange={(e) => {
							// set id of course
							setProject(e.target.value);
						}}
					>
						<option value="">Select Projects</option>
						{projects.map((val) => {
							return (
								<option value={val._id} key={val.id}>
									{val?.projectName}
								</option>
							);
						})}
					</select>
				</div>
				{/* delete button */}
				<button
					className="btn btn-primary"
					style={{
						width: "100%",
						marginTop: "30px",
						marginBottom: "20px",
					}}
					onClick={handleSubmit}
				>
					Delete Project
				</button>
			</div>
		</div>
	);
};

export default DeleteProject;
